import { Overlay, OverlayProps } from './Overlay';

/** Right-edge drawer from 640 px (480 wide), bottom sheet below. */
export const Drawer = (props: OverlayProps) => <Overlay variant="drawer" {...props} />;
